import PropTypes from "prop-types";
import classNames from "classnames";
import { withBlur } from "../hoc/withBlur";
import classes from "./Price.module.css";

const Price = (props) => {
  const {
    className,
    valueClassName,
    suffixClassName,
    value,
    suffix,
    isBlurred,
  } = props;

  return (
    <p className={classNames(classes["price"], className)}>
      <span
        className={classNames(
          classes["price__value"],
          "numeric-content",
          valueClassName,
          {
            [classes["price__value--blurred"]]: isBlurred,
          }
        )}
      >
        {isBlurred ? "???" : value}
      </span>
      <span className={classNames(classes["price__suffix"], suffixClassName)}>
        {suffix}
      </span>
    </p>
  );
};

export default withBlur(Price);

Price.propTypes = {
  className: PropTypes.string,
  valueClassName: PropTypes.string,
  suffixClassName: PropTypes.string,
  value: PropTypes.number,
  suffix: PropTypes.string,
  isBlurred: PropTypes.bool,
};
